
import {createPopper} from '@popperjs/core'

export default {
    name: 'DropDownMenu',
    props: {
        position: {
            type: String,
            default: 'bottom'
        },
        offset: {
            type: Array,
            default: () => [10, 10]
        }
    },
    data () {
        return {
            popper: null,
            contextData: null,
            opened: false
        }
    },
    beforeDestroy() {
        if (this.popper) {
            this.popper.destroy()
        }
    },
    methods: {
        open (evt, contextData) {
            this.opened = true
            this.contextData = contextData

            if (this.popper) {
                this.popper.destroy()
            }

            // Recalculate position
            this.$nextTick(() => {
                const virtualElement = 'getBoundingClientRect' in evt ? evt : {
                    getBoundingClientRect: this.generateGetBoundingClientRect(evt.clientX, evt.clientY)
                }

                this.popper = createPopper(virtualElement, this.$refs.popper, {
                    placement: this.position,
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: this.offset
                            }
                        }
                    ]
                })
            })
        },
        close () {
            this.opened = false
            this.contextData = null
        },
        generateGetBoundingClientRect (x = 0, y = 0) {
            return () => ({
                width: 0,
                height: 0,
                top: y,
                right: x,
                bottom: y,
                left: x
            })
        },
        referenceObject (evt) {
            const left = evt.clientX
            const top = evt.clientY
            const right = left + 1
            const bottom = top + 1

            function getBoundingClientRect () {
                return { left, top, right, bottom }
            }

            return { getBoundingClientRect, contextElement: evt.srcElement }
        }
    }
}
